import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledInput = styled(TextField)(({ theme }) => ({
  '& .MuiFilledInput-root': {
    border: `1px solid ${theme.palette.divider}`,
    overflow: 'hidden',
    borderRadius: theme.spacing(6),
    backgroundColor: 'transparent',
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&.Mui-focused': {
      backgroundColor: 'transparent',
      boxShadow: `0 0 0 0 2px`,
      borderColor: theme.palette.divider,
    },
    '&.Mui-error': {
      borderColor: theme.palette.error.main,
    },
    '&.Mui-disabled': {
      backgroundColor: '#F4F6F8',
      input: {
        color: theme.palette.grey.A100,
        "-webkit-text-fill-color": theme.palette.grey.A100
      },
    },
  },
  '& ::placeholder': {
    color: theme.palette.divider,
  },
  '& label': {
    color: theme.palette.divider,
    paddingLeft: theme.spacing(6),
    '&.Mui-focused': {
      color: theme.palette.divider,
    },
    '&.Mui-error': {
      color: theme.palette.error.main,
    },
    '&.Mui-disabled': {
      color: theme.palette.grey.A100,
    },
  },
}));
